import type React from 'react';

interface CursorWhiteIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function CursorWhiteIcon({ size = 24, ...props }: CursorWhiteIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_17078_21795)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4334 10.2065L14.209 8.86465L4.0614 3.28564L7.01976 14.4815L9.23515 11.1426L11.8875 14.5375L13.0857 13.6014L10.4334 10.2065Z"
          fill="white"
        />
        <path
          d="M4.2323 2.97412L14.3807 8.55322L15.0741 8.93408L14.328 9.19971L11.0165 10.3755L13.3661 13.3823L13.5848 13.6626L13.3046 13.8813L12.1063 14.8179L11.826 15.0366L11.6073 14.7563L9.25769 11.7495L7.31628 14.6782L6.87781 15.3374L6.67566 14.5728L3.71765 3.37646L3.50574 2.57471L4.2323 2.97412Z"
          stroke="#222222"
          strokeWidth="0.711095"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_17078_21795"
          x="0.816726"
          y="0.440846"
          width="17.2557"
          height="18.5976"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.711095" />
          <feGaussianBlur stdDeviation="1.06664" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17078_21795" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_17078_21795"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
